import React, { Component, Fragment } from 'react';
import DEFINE from "../../../../constants/Define";
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import LocationList from './LocationList';
import Ripple from '../../common/component/Ripple';

let permisionActions = [];
export default class Locations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.locationState.pageSize,
                pageIndex: this.props.locationState.pageIndex,
            }
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.LOCATION);
        this.props.getListLocations(this.state.filters);
    }

    render() {
        const { t, match } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, dataList } = this.props.locationState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};

        return (
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'locations'}
                        titleHeader={t('navigation.locations')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={`/locations/action`}
                                        className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <LocationList loading={isFetching}
                        hotelId={match.params.hotel_id}
                        permisions={permisionActions}
                        dataList={dataList}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onDeleteLocation={this.onDeleteLocation}
                        />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let curfilters = this.state.filters;
        if (filters.status) {
            switch (filters.status[0]) {
                case 998:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'isExpired');
                    filters.IsLocked = true;
                    break;
                case 999:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'IsLocked');
                    filters.isExpired = true;
                    break;
                default:
                    if (filters.status[0] !== 998) { curfilters = Func.removeElementObject(curfilters, 'IsLocked') }
                    if (filters.status[0] !== 999) { curfilters = Func.removeElementObject(curfilters, 'isExpired') }
            }
        }
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListLocations(newFilters);
    };

    onDeleteLocation = (item) => {
        this.props.deleteLocation(item, { 
            pageSize: this.props.locationState.pageSize, 
            pageIndex: this.props.locationState.pageIndex
        })
    }
}